import _, { isNaN } from "lodash";
import { CONST_VALUES } from "../constants/constants";
import { STATUS_COLORS } from "../constants/statuses";
import { PERFORMANCE_DATE_FORMATS } from "../constants/dateFormat";
import moment from "moment";

export const STORAGE_OPTIONS_VALUE = {
  block: "1",
  object: "2",
  file: "3"
};

export const STORAGE_OPTIONS_TYPE = {
  "1": "block",
  "2": "object",
  "3": "file"
};
export const shouldShowIcon = value => {
  let arrayOfvalues = ["online", "enabled"];
  return arrayOfvalues.includes(value);
};

export const checkTruthyValue = value => {
  let arrayOfvalues = ["true"];
  if (!!value) {
    return arrayOfvalues.includes(value.toString().toLowerCase());
  }
  return false;
};

export const showInKiBUnit = value => {
  let arrayOfvalues = ["block size", "capacity", "used", "deduped size"];
  if (!!value) {
    return arrayOfvalues.includes(value.toString().toLowerCase());
  }
  return false;
};

export const isRoleCustomer = role => {
  if (role) {
    return role === CONST_VALUES.CUSTOMER;
  }
  return false;
};

export const isRolePartner = role => {
  if (role) {
    return role === CONST_VALUES.PARTNER;
  }
  return false;
};

export const isRoleIntUser = role => {
  if (role) {
    return role === CONST_VALUES.INTUSER;
  }
  return false;
};

export const roundoff = (num, NaNReturnValue = "NA") => {
  if (isNaN(parseFloat(num))) {
    return NaNReturnValue;
  } else {
    try {
      num = removeCommaFromString(num);
      return parseFloat(num)
        .toFixed(2)
        .toLocaleString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } catch {
      return NaNReturnValue;
    }
  }
};

const isString = value => {
  return typeof value === "string";
};
const removeCommaFromString = value => {
  return isString(value) ? value.replace(/,/g, "") : value;
};
export const roundToTwoDecimalPlaces = value => {
  // Multiply the value by 1000 to shift the decimal three places to the right
  const rounded = Math.round(value * 1000) / 1000; // Round to three decimal places
  return (Math.round(rounded * 100) / 100).toFixed(2); // Round to two decimal places
};

export const sortByColumnName = (data, columns) => {
  return _.sortBy(data, columns, ["asc", "asc"]);
};

export const getStatusColorCodes = (
  usedColor,
  assetsThreshold,
  percent = 0
) => {
  const criticalLimit = !!assetsThreshold
    ? parseInt(assetsThreshold.Critical)
    : 90;
  const warningLimit = !!assetsThreshold
    ? parseInt(assetsThreshold.Warning)
    : 80;
  let color;
  switch (true) {
    case percent >= criticalLimit:
      color = STATUS_COLORS.CRITICAL;
      break;
    case percent >= warningLimit:
      color = STATUS_COLORS.WARNING;
      break;
    default:
      color = usedColor;
      break;
  }
  return color;
};

export const checkAllLegendsDisable = (legendsArray, showHideLegends) => {
  return (
    legendsArray &&
    legendsArray.length > 0 &&
    legendsArray.every(
      (element, index) =>
        showHideLegends && showHideLegends[legendsArray[index]] === false
    )
  );
};
export const sliceIntoChunks = (arr, chunkSize) => {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr?.slice(i, i + chunkSize).join("-");
    res.push(chunk);
  }
  return res;
};

export const breakTextIntoLines = (text, maxWidth) => {
  const words = text?.split("-");
  const lines = [];
  let currentLine = "";
  for (const word of words) {
    const proposedLine = `${currentLine} ${word}`;
    const proposedWidth = proposedLine?.length * 5; // Approximate width calculation based on font size

    if (proposedWidth <= maxWidth) {
      currentLine = proposedLine;
    } else {
      let arrayEle = currentLine?.trim(" ").split(" ");
      lines.push(...sliceIntoChunks(arrayEle, 3));
      currentLine = word;
    }
  }
  let arrayElement = currentLine?.trim(" ").split(" ");
  lines.push(...sliceIntoChunks(arrayElement, 3));
  return lines;
};

export const breakTextIntoLinesPool = (text, maxWidth) => {
  const lines = [];
  let line = "";

  for (let i = 0; i < text.length; i++) {
    line += text[i];
    if (line.length >= maxWidth) {
      lines.push(line);
      line = ""; // Reset line after maxWidth is reached
    }
  }

  if (line) {
    lines.push(line); // Add any remaining text
  }

  return lines;
};

export const isArrayAllNull = arr => {
  return arr?.every(element => element === null) || arr?.length <= 0;
};

export function checkAccessStateCondition(data) {
  let value = data?.toLowerCase();
  return value === "no access" || value === "none" || value === "unknown";
}

export function validateStorageValue() {
  const validOptions = ["overview", "sustainability", "security"];
  return validOptions?.includes(localStorage.getItem("storageOption"));
}

export const getAreaDescription = (data, nullDataLabels, noAccessMsg) => {
  if (data?.hasOwnProperty("message") && noAccessMsg[data?.message]) {
    return noAccessMsg[data?.message].label
      .toLowerCase()
      .split(" ")
      .join("-");
  }
  if (nullDataLabels?.labels?.length === 0) {
    return "all-data";
  }
  if (
    nullDataLabels?.labels?.length === data?.average?.length ||
    nullDataLabels?.labels?.length === data?.used?.length ||
    nullDataLabels?.labels?.length ===
      data?.record?.[1]?.average_display?.length
  ) {
    return "no-data";
  }
  return "partial-data";
};

export function getXAxisLabel(selected) {
  if (selected === "Week" || selected == "Forecast" || selected == "SLA") {
    return "Day";
  } else if (selected === "Month") {
    return "Date";
  } else if (selected === "Day") {
    return "Hour";
  } else {
    return "Month";
  }
}

export function getFormattedDateTime(date, format) {
  return moment(date)?.isValid() ? moment(date)?.format(format) : "";
}

export const calculateTotal = (used = 0, total = 0) => {
  let completed = (used / total) * 100;
  if (completed < 0.9 && completed > 0) {
    completed = 0.9;
  } else if (isNaN(completed)) {
    completed = 0;
  } else {
    completed = (used / total) * 100;
  }
  return completed;
};

export const getErrorMessage = (data = "") => {
  return (
    data?.message ||
    (data.isDataNotPresent && CONST_VALUES.NOT_ENOUGH_DATA_COLLECTED_YET)
  );
};
export const getPerformanceSupportStatus = (siteInfo, selectedAsset) => {
  const selectedAssets = Array.isArray(selectedAsset)
    ? selectedAsset
    : [selectedAsset];
  const filteredInfo = siteInfo?.filter(info =>
    selectedAssets?.some(
      asset =>
        info?.site_id === (asset?.siteId || asset?.site_id) &&
        info?.serial_id ===
          (asset?.serialNumber || asset?.serial_id || asset?.serial_number) &&
        info?.product_family_id == asset?.product_family_id
    )
  );
  return filteredInfo?.length > 0
    ? filteredInfo[0]?.is_performance_supported
    : false;
};

const calculateStorageData = (
  totalCapacity,
  usedCapacity,
  availableCapacity,
  unit,
  totalLabel,
  usedRateLabel,
  usedLabel,
  availableLabel,
  unitLabel
) => {
  return {
    [totalLabel]: totalCapacity,
    [usedRateLabel]:
      totalCapacity !== 0 ? (usedCapacity / totalCapacity) * 100 : 0,
    [usedLabel]: usedCapacity,
    [availableLabel]: availableCapacity,
    [unitLabel]: unit
  };
};

export const updatePrimaryStorage = storageData => {
  let {
    primary_storage_capacity = 0,
    primary_storage_used_capacity = 0,
    primary_storage_available_capacity = 0,
    s_series_storage_capacity = 0,
    s_series_storage_used_capacity = 0,
    s_series_storage_available_capacity = 0,
    licensed_capacity = 0,
    licensed_used_capacity = 0,
    licensed_available_capacity = 0,
    extended_licensed_capacity = 0,
    extended_used_capacity = 0,
    extended_available_capacity = 0,
    external_storage_capacity = 0,
    external_storage_available_capacity = 0,
    external_storage_used_capacity = 0
  } = storageData || "";

  if (storageData) {
    primary_storage_available_capacity += external_storage_available_capacity;
    primary_storage_capacity += external_storage_capacity;
    primary_storage_used_capacity += external_storage_used_capacity;
  }

  return {
    physicalStorageData: calculateStorageData(
      licensed_capacity,
      licensed_used_capacity,
      licensed_available_capacity,
      CONST_VALUES.TiB,
      "total_physical_storage",
      "physical_used_rate_percentage",
      "physical_used",
      "physical_available",
      "physical_unit"
    ),
    extendedStorageData: calculateStorageData(
      extended_licensed_capacity,
      extended_used_capacity,
      extended_available_capacity,
      CONST_VALUES.TiB,
      "total_extended_storage",
      "extended_used_rate_percentage",
      "extended_used",
      "extended_available",
      "extended_unit"
    ),
    primaryStorageData: calculateStorageData(
      primary_storage_capacity,
      primary_storage_used_capacity,
      primary_storage_available_capacity,
      CONST_VALUES.TiB,
      "total_physical_storage",
      "physical_used_rate_percentage",
      "physical_used",
      "physical_available",
      "physical_unit"
    ),
    s_seriesStorageData: calculateStorageData(
      s_series_storage_capacity,
      s_series_storage_used_capacity,
      s_series_storage_available_capacity,
      CONST_VALUES.TiB,
      "total_extended_storage",
      "extended_used_rate_percentage",
      "extended_used",
      "extended_available",
      "extended_unit"
    )
  };
};

export const formatLabel = (label, selected) => {
  if (selected === "Week") {
    return moment.utc(label).format("D MMM");
  } else if (selected === "Day") {
    return moment(label).format(PERFORMANCE_DATE_FORMATS[selected]);
  } else {
    return moment.utc(label).format(PERFORMANCE_DATE_FORMATS[selected]);
  }
};

export const getformatedLabels = (labels, selected) => {
  return labels.map(label => formatLabel(label, selected));
};

export const modifyInitialData = data => {
  if (Array.isArray(data)) {
    const updatedAssets = data?.map((item, index) => ({
      ...item,
      selected_index: index,
      isChecked: false,
      entitlement_category_ids: []
    }));
    return updatedAssets;
  } else {
    return [];
  }
};

//Function to get selected asset user site information

export const getSelectedAssetUserSiteInfoUtil = (
  selectedAssets,
  userSiteInfo
) => {
  if (!selectedAssets || selectedAssets.length === 0 || !userSiteInfo)
    return [];

  const userSiteInfoKeys = Object.keys(userSiteInfo);
  let selectedClusterKey = [];

  userSiteInfoKeys.forEach(item => {
    selectedAssets.forEach((asset, index) => {
      if (
        (asset?.serialNumber &&
          asset?.serialNumber.toUpperCase() ===
            userSiteInfo[item].serial_id.toUpperCase() &&
          asset?.siteId.toUpperCase() ===
            userSiteInfo[item].site_id.toUpperCase() &&
          asset?.product_family_id === userSiteInfo[item].product_family_id) ||
        (asset?.serial_id &&
          asset?.serial_id.toUpperCase() ===
            userSiteInfo[item].serial_id.toUpperCase() &&
          asset?.site_id.toUpperCase() ===
            userSiteInfo[item].site_id.toUpperCase() &&
          asset?.product_family_id === userSiteInfo[item].product_family_id) ||
        (asset?.serialId &&
          asset?.serialId.toUpperCase() ===
            userSiteInfo[item].serial_id.toUpperCase() &&
          asset?.siteId.toUpperCase() ===
            userSiteInfo[item].site_id.toUpperCase() &&
          asset?.product_family_id === userSiteInfo[item].product_family_id)
      ) {
        selectedClusterKey.push(userSiteInfo[item]);
      }
    });
  });

  return selectedClusterKey;
};

export const iOSExternalLinks = url => {
  if (url) {
    const decodedUrl = decodeURIComponent(url);

    // Check if running in an iOS environment
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (isIOS) {
      // Use a different approach for iOS, such as `window.location.href`
      const a = document.createElement("a");
      a.href = decodedUrl;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.click();
    } else {
      // Regular approach for non-iOS browsers
      window.open(decodedUrl, "_blank", "noopener");
    }
  }
};

export const getKeyForSfdcMap = params => {
  const marketing_name = decodeURIComponent(params?.marketingname)
    ?.split(" ")
    ?.join("_")
    ?.toLowerCase();
  const sfdcId = params?.siteId;
  const serialId = params?.serialNumber;
  let key = `${sfdcId}_${marketing_name}_${serialId}`;
  return key;
};

export const filteredAssetBasedOnCategory = (
  array = [],
  product_category_id = ""
) => {
  return (
    array?.filter(el => el?.product_category_id === product_category_id) || []
  );
};

export const handleExpiredCase = supportExpiredRange => {
  const lowerCaseRange = supportExpiredRange?.toLowerCase();
  if (
    lowerCaseRange === "contact your asp" ||
    lowerCaseRange === "not applicable" ||
    lowerCaseRange === "no access"
  ) {
    return supportExpiredRange;
  }
  if (
    typeof supportExpiredRange === "string" &&
    !supportExpiredRange.includes("year")
  ) {
    const parsedRange = parseInt(supportExpiredRange.replace(" days", ""), 10);
    return isNaN(parsedRange) ? supportExpiredRange : parsedRange; // Return parsed days or original string if parsing fails
  }
  return supportExpiredRange; // Return the original value if no processing is needed
};

export const getRemainingDays = supportExpiredRange => {
  const processedRange = handleExpiredCase(supportExpiredRange);
  if (typeof processedRange === "number" && !isNaN(processedRange)) {
    return 30 - Math.abs(processedRange);
  }
  return processedRange; // Return the non-numeric value (like "contact your asp") directly
};

export const getSupportExpiredRange = supportExpiredRange => {
  return handleExpiredCase(supportExpiredRange); // Process and return the final value
};

export const showThreeDots = (value, isLastElement) => {
  return value?.length > 10 && !isLastElement
    ? "...:"
    : value?.length > 10 && isLastElement
    ? "..."
    : isLastElement
    ? ""
    : ":";
};

const buildUtcIsoString = value => {
  if (!value) return "";

  const dateOnlyMatch = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const dateTimeWithSpaceMatch = /^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(
    value
  );

  if (dateOnlyMatch) {
    return `${value}T00:00:00.000Z`;
  }

  if (dateTimeWithSpaceMatch) {
    const [datePart, timePartRaw = ""] = value.split(" ");
    const [timePart, fraction = ""] = timePartRaw.split(".");
    const milliseconds = fraction ? fraction.slice(0, 3).padEnd(3, "0") : "000";
    return `${datePart}T${timePart}.${milliseconds}Z`;
  }

  const parsed = Date.parse(value);
  if (Number.isNaN(parsed)) return "";
  return new Date(parsed).toISOString();
};

export const formatUtcTimestampToRelative = utcDateTime => {
  if (!utcDateTime) return "";

  const isoUtc = buildUtcIsoString(utcDateTime);
  if (!isoUtc) return "";

  const utcMs = Date.parse(isoUtc);
  if (Number.isNaN(utcMs)) return "";

  const diffSec = Math.max(0, Math.floor((Date.now() - utcMs) / 1000));
  if (diffSec < 60) return "just now";

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin} min ago`;

  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr} hour${diffHr > 1 ? "s" : ""} ago`;

  const diffDay = Math.floor(diffHr / 24);
  return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
};

export const formatUtcCollectionTimestamp = value => {
  if (!value) return "Data Not available";

  const isoUtcString = buildUtcIsoString(value);
  if (!isoUtcString) return value;

  const utcDate = new Date(isoUtcString);
  if (Number.isNaN(utcDate.getTime())) return value;

  const year = utcDate.getUTCFullYear();
  const month = String(utcDate.getUTCMonth() + 1).padStart(2, "0");
  const day = String(utcDate.getUTCDate()).padStart(2, "0");
  const hours24 = utcDate.getUTCHours();
  const minutes = String(utcDate.getUTCMinutes()).padStart(2, "0");
  const meridiem = hours24 >= 12 ? "PM" : "AM";
  const hours12 = String(hours24 % 12 || 12).padStart(2, "0");

  return `${year}-${month}-${day} ${hours12}:${minutes} ${meridiem}`;
};

// export const handleExpiredCase =(supportExpiredRange)=>{
//   if (
//     supportExpiredRange?.toLowerCase() === "contact your asp" ||
//     supportExpiredRange?.toLowerCase() == "not applicable" ||  supportExpiredRange?.toLowerCase() == 'no access'
//   ) {
//     return supportExpiredRange;
//   } else if (
//     typeof supportExpiredRange === "string" &&
//     !supportExpiredRange?.includes("year")
//   ) {
//     supportExpiredRange = parseInt(
//       supportExpiredRange.replace(" days", ""),
//       10
//     );
//   } else {
//     //do nothing
//   }
// }

// export const getRemainingDays = supportExpiredRange => {

//   const remainingDays = 30 - Math.abs(supportExpiredRange);
//   return remainingDays;
// };

// export const getSupportExpiredRange = supportExpiredRange => {
//   if (
//     supportExpiredRange?.toLowerCase() === "contact your asp" ||
//     supportExpiredRange?.toLowerCase() == "not applicable" ||  supportExpiredRange?.toLowerCase() == 'no access'
//   ) {
//     return supportExpiredRange;
//   } else if (
//     typeof supportExpiredRange === "string" &&
//     !supportExpiredRange?.includes("year")
//   ) {
//     supportExpiredRange = parseInt(
//       supportExpiredRange.replace(" days", ""),
//       10
//     );
//   } else {
//     //do nothing
//   }
//   return supportExpiredRange;
// };
